import { PageHeader } from "antd";
import React, { Component } from "react";
import axios from 'axios'
import { cuentaMask, dineroDisabledMask, TableItemDinamico} from '../../../Components/Items'
import { connect } from "react-redux";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");


class CargosAbonos extends Component {
  tableRef = React.createRef();
  state = {
    todasCargoAbono: [],
    totalRecords: 0,
    loading: false
  }


  consultarCargosAbonos(params) {
    this.setState({loading: true})
    axios
    .post(
      "cargosabonos/selectCargosAbonos",
      { empresaId: this.props.empresaId, ...params },
      {
        headers: this.props.headersToken,
      }
    )
    .then((res) => {
      if (res.data.success === 2) {
        // let cargosTotal = 0
        // let abonosTotal = 0
        const todasCargosAbonos = res.data.data.map(value => {
            let cargos = 0
            let abonos = 0
            if(value.cargo){
                cargos = value.monto
                // cargosTotal += value.monto
            }else{
                abonos = value.monto
                // abonosTotal += value.monto
            }
          return {...value, cargos, abonos, poliza: {poliza: value?.poliza, tipodepoliza: value?.tipodepoliza}}
        }).slice(0, 100)
        // todasCargosAbonos.push({
        //   proyecto: {nombre: 'Total: '}, 
        //   cuentacontable: {nivel1: '', nivel2: '', nivel3: '', nivel4: '', nivel5: '', descripcion: 'Total: '},
        //   cargos: cargosTotal, 
        //   abonos: abonosTotal, 
        //   poliza: undefined, 
        //   concepto: 'total',
        // })
        this.setState({
          todasCargoAbono: todasCargosAbonos,
            totalRecords: res.data.totalRecords || 0, 
            loading: false
        });
      } else {
        this.setState({ todasCargoAbono: [], loading: false });
      }
    });
  }
  render() {
    const columns = [
      {
        title: "Cuenta",
        dataIndex: "cuentacontable",
        key: "cuentacontable",
        render: (value) => cuentaMask(value.nivel1+value.nivel2+value.nivel3+value.nivel4+value.nivel5),
        width: '10%'
      },
      {
        title: "Descripción",
        dataIndex: "cuentacontable",
        key: "cuentacontable",
        render: (value) => value.descripcion,
        width: '20%'
      },
      {
        title: "Fecha",
        dataIndex: "fechaRegistro",
        key: "fechaRegistro",
        sorter: true,
        render: (value) => moment(value).locale('es').format('L'),
        width: '10%',
      },
      {
        title: "Cargo",
        dataIndex: "cargos",
        key: "cargos",
        render: (value, record) => value === 0 ? '' : `${dineroDisabledMask(value)} ${record.moneda?.abreviacion || record.moneda || ''}`,
        width: '10%'
      },
      {
        title: "Abono",
        dataIndex: "abonos",
        key: "abonos",
        render: (value, record) => value === 0 ? '' : `${dineroDisabledMask(value)} ${record.moneda?.abreviacion || record.moneda || ''}`,
        width: '10%'
      },
      {
        title: "Poliza",
        dataIndex: "poliza",
        key: "poliza",
        render: (value) => {
          if(value){
            let ied = ''
            if(value.tipodepoliza.tipoDePolizaId === 1)ied = 'Ingreso'
            if(value.tipodepoliza.tipoDePolizaId === 2)ied = 'Egreso'
            if(value.tipodepoliza.tipoDePolizaId === 3)ied = 'Traslado'
            if(value.tipodepoliza.tipoDePolizaId === 4)ied = 'Nomina'
            if(value.tipodepoliza.tipoDePolizaId === 5)ied = 'Pago'
            if(value.tipodepoliza.tipoDePolizaId === 6)ied = 'Diario'
            return value.tipodepoliza.descripcion+': '+value.poliza.numeroTipoPoliza+' - '+ied+': '+value.poliza.numeroTipoTipoPoliza
          }
        },
        width:'20%'
      },
      {
        title: "Concepto",
        dataIndex: "concepto",
        key: "concepto",
        width:'20%'
      }
    ]
    return (
      <>
        <PageHeader
          title="Cargos Abonos"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <TableItemDinamico
          ref={(ref) => this.tableRef = ref}
          onRef={(ref) => this.tableRef = ref}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          onFetchData={this.consultarCargosAbonos.bind(this)}
          size="small"
          dataSource={this.state.todasCargoAbono}
          columns={columns}
          pagination={false}
          filterStorageKey={"cargosAbonosFiltrosTabla" + this.props.empresaId}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(CargosAbonos);